import { RECENT_SEARCHES } from 'tradera/constants/cookies';
import { MAX_RECENT_SEARCHES_STORED_IN_COOKIES } from 'tradera/state/personalisation/constants';
import { getRecentSearchesLocalStorage } from 'tradera/state/personalisation/helpers';
import type { RecentSearch } from 'tradera/state/personalisation/reducer';
import cookieUtil from 'tradera/utils/cookie';
import {
    stripItmFromQueryParameters,
    formatQueryParams,
    toQueryParameters,
    toSearchString
} from 'tradera/utils/url';

export const parseRecentSearchesFromCookiesString = (
    cookieString: string
): RecentSearch[] => {
    if (!cookieString) {
        return [];
    }

    try {
        const json = JSON.parse(cookieString);

        return json.map((item: string) => {
            const queryParams = stripItmFromQueryParameters(
                formatQueryParams(toQueryParameters(item))
            );
            return {
                text: queryParams.q,
                queryParams: queryParams
            };
        });
    } catch {
        return [];
    }
};

const mapToCookie = (
    recentSearches: RecentSearch[],
    limit: number
): string[] => {
    const mapped = recentSearches.slice(0, limit).map((item) => {
        return toSearchString(item.queryParams);
    });

    return mapped;
};

export const syncLocalStorageToCookies = () => {
    const recentSearches = getRecentSearchesLocalStorage();
    const mapped = mapToCookie(
        recentSearches,
        MAX_RECENT_SEARCHES_STORED_IN_COOKIES
    );
    const cookieString = JSON.stringify(mapped);
    cookieUtil.createCookie(RECENT_SEARCHES, cookieString, 365);
    return cookieString;
};
